import { IFilter } from '../../types/advancedFilters';
import { RentalPeriodContainer } from '../../containers/advancedFilters/RentalPeriodContainer';

export const rentalPeriod: IFilter = {
  component: RentalPeriodContainer,
};
